var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.esEdicion
                            ? "Editar Movimiento "
                            : "Ver Movimiento "
                        ) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer"),
                  _c("v-toolbar-items")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-tabs",
                          [
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "general"
                                  }
                                }
                              },
                              [_vm._v("General")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "seriados"
                                  }
                                }
                              },
                              [_vm._v("Equipos Seriados")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "noSeriados"
                                  }
                                }
                              },
                              [_vm._v("Equipos No Seriados")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "sim"
                                  }
                                }
                              },
                              [_vm._v("SIM")]
                            )
                          ],
                          1
                        ),
                        _vm.step == "general"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("informacionGeneral", {
                                  ref: "general",
                                  attrs: {
                                    edited: _vm.data,
                                    despachos: _vm.despachosList,
                                    estados: _vm.estados,
                                    esEdicion: _vm.esEdicion,
                                    usuarioActivo: _vm.usuarioActivo,
                                    receptor: _vm.receptorSelected,
                                    recibido: _vm.recibido
                                  },
                                  on: {
                                    receptor: function($event) {
                                      _vm.receptorSelected = $event
                                    },
                                    edicion: function($event) {
                                      _vm.dialogGuardar = $event
                                    },
                                    textoModal: function($event) {
                                      _vm.textoConfirmacion = $event
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "seriados"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _vm.esEdicion
                                  ? _c("DispositivosSeriadosEdicion", {
                                      attrs: {
                                        codigo: _vm.data.movinumero,
                                        mostrarSerie: true
                                      }
                                    })
                                  : _c("DispositivosSeriadosDetalles", {
                                      attrs: {
                                        codigo: _vm.data.movinumero,
                                        mostrarSerie: true
                                      }
                                    })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "noSeriados"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _vm.esEdicion
                                  ? _c("DispositivosNoSeriadosEdicion", {
                                      attrs: {
                                        codigo: _vm.data.movinumero,
                                        mostrarNoSerie: true,
                                        esEdicion: _vm.esEdicion
                                      }
                                    })
                                  : _c("DispositivosNoSeriadosDetalles", {
                                      attrs: {
                                        codigo: _vm.data.movinumero,
                                        mostrarNoSerie: true
                                      }
                                    })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "sim"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("DispositivosSim", {
                                  attrs: {
                                    codigo: _vm.data.movinumero,
                                    mostrarSim: true,
                                    esEdicion: _vm.esEdicion
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje:
            "Al cerrar esta ventana toda la información editable se perderá ¿Esta seguro que desea cerrar sin guardar? ",
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogGuardar,
          titulo: "Editar el movimiento número " + _vm.data.movinumero,
          mensaje: _vm.textoConfirmacion,
          textoBtnSi: "Guardar cambios",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.editarMovimiento($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }